export const BLOG_BASE_URL_LOCAL_HOST = "http://localhost:5000";

export const BLOG_BASE_URL = "https://courses-api-j67q.onrender.com";

export const url = BLOG_BASE_URL || BLOG_BASE_URL_LOCAL_HOST;
